module.exports = __webpack_public_path__ + "img/red_car.9e656b94.jpg";